module.exports = __webpack_public_path__ + "img/對分相.105e5e80.svg";